// BarIndicator — base horizontal bar chart of the Analysis view (US-879 ·
// R-2/R-6). A thin Recharts wrapper: rows + bar series arrive fully built
// from config/analysisConfig.js, colors are theme tokens — nothing visual is
// decided here, so US-880/881 reuse it by adding config entries.
import Box from "@mui/material/Box";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { colors, fonts } from "../../../theme/tokens";

const AXIS_TICK = { fontSize: 11, fontFamily: fonts.sans, fill: colors.annotation };

// data: [{ name, <dataKey>: number }], bars: [{ dataKey, label, color }],
// unit: axis suffix (e.g. "%"), max: numeric axis upper bound (optional).
const BarIndicator = ({ data, bars, unit = "", max }) => (
  <Box sx={{ width: "100%", height: 40 + data.length * (28 * bars.length + 16) }}>
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} layout="vertical" margin={{ top: 0, right: 12, bottom: 0, left: 0 }}>
        <CartesianGrid horizontal={false} stroke={colors.borderLight} />
        <XAxis
          type="number"
          domain={[0, max ?? "auto"]}
          unit={unit}
          tick={AXIS_TICK}
          axisLine={{ stroke: colors.borderMedium }}
          tickLine={false}
        />
        <YAxis
          type="category"
          dataKey="name"
          width={92}
          tick={AXIS_TICK}
          axisLine={false}
          tickLine={false}
        />
        <Tooltip
          formatter={(value) => `${value}${unit}`}
          contentStyle={{
            fontFamily: fonts.sans,
            fontSize: 12,
            border: `1px solid ${colors.borderLight}`,
            borderRadius: 6,
          }}
        />
        {bars.length > 1 && (
          <Legend wrapperStyle={{ fontFamily: fonts.sans, fontSize: 12 }} />
        )}
        {bars.map(({ dataKey, label, color }) => (
          <Bar
            key={dataKey}
            dataKey={dataKey}
            name={label}
            fill={color}
            barSize={12}
            radius={[0, 3, 3, 0]}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  </Box>
);

export default BarIndicator;
